import ReactDOM from 'react-dom/client';
import { configureAxiosOwnershipInterceptors } from './api/httpInterceptors';
import './i18n';
import App from './App';

configureAxiosOwnershipInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
